module.exports = __webpack_public_path__ + "img/logo.991b8a27.svg";